import { gql } from '@apollo/client';

export const DELETE_TEMPLATE = gql`
mutation delete_template ($id: Int!, $userId: Int, $time: timestamptz) {
    update_msgbox_Template(
      where: {TemplateId: {_eq: $id}},
      _set: {IsDeleted:true, DeletedBy: $userId, DeletedOn:$time}) {
      affected_rows
    }
  }
  `
  